import React from 'react';
import { motion } from 'framer-motion';
import { BRAND } from '../data/content';
import { SocialLinks } from './SocialLinks';
import { SmartImage } from './SmartImage';
import { ArrowRightIcon, WhatsappIcon } from './icons/LineIcons';
export function Hero() {
  return <section id="inicio" className="relative w-full overflow-hidden bg-ink pt-24 sm:pt-28 lg:pt-32" aria-label="Norberth Presenta" data-id="element-171" data-mp="9igvb8esxojn">
      {/* Ambient lighting */}
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-10 h-[380px] w-[380px] rounded-full bg-gold/10 blur-3xl" data-id="element-172" data-mp="127edlbj0jlce" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 top-1/3 hidden h-[320px] w-[320px] rounded-full bg-gold/[0.07] blur-3xl lg:block" data-id="element-173" data-mp="s9zz3hgnh6mq" />
      <div aria-hidden="true" className="grain pointer-events-none absolute inset-0 opacity-40" data-id="element-174" data-mp="3d1sayygxbltn" />

      <div className="relative mx-auto max-w-7xl px-5 pb-16 sm:pb-20 lg:px-10 lg:pb-24" data-id="element-175" data-mp="381nqyygt48yo">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="relative" data-id="element-176" data-mp="3j9u1r1hjpsmv">
          <div aria-hidden="true" className="absolute -inset-x-6 -inset-y-6 rounded-[18px] bg-gold/[0.06] blur-3xl" data-id="element-177" data-mp="399jojgvigl7p" />
          <div className="relative overflow-hidden rounded-[12px] border border-white/[0.08] bg-graphite shadow-[0_40px_120px_-40px_rgba(0,0,0,0.95)]" data-id="element-178" data-mp="30i19j9aawbg7">
            <SmartImage src={BRAND.bannerUrl} alt="Norberth Pérez — Historias que conectan. Marcas que crecen." priority width={1966} height={771} wrapperClassName="aspect-[1966/771] w-full" className="absolute inset-0 h-full w-full object-cover" data-id="element-179" data-mp="35aatm8oqihak" />
            <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" data-id="element-180" data-mp="2lla5untlgdks" />
          </div>
        </motion.div>

        {/* Readable headline on smaller screens where the banner type is small */}
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: 'easeOut'
      }} className="mt-10 font-display text-4xl uppercase leading-[0.98] tracking-tight text-white sm:text-5xl lg:sr-only" data-id="element-181" data-mp="id9tudnwcbtt">
          Historias que <span className="text-gold" data-id="element-182" data-mp="162cd1py6icqf">conectan.</span>
          <br data-id="element-183" data-mp="1126o4hjan4c1" />
          Marcas que <span className="text-gold" data-id="element-184" data-mp="111es55lsb4l8">crecen.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.25,
        ease: 'easeOut'
      }} className="mt-8 flex flex-col gap-6 lg:mt-12 lg:flex-row lg:items-center lg:justify-between" data-id="element-185" data-mp="x1nwoolbc0ad">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-186" data-mp="1x9kwssxc7gkd">
            <a href="#reunion" className="group inline-flex items-center justify-center gap-3 rounded-md bg-gold px-7 py-4 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-all duration-300 hover:bg-goldsoft hover:shadow-[0_0_40px_-10px_rgba(245,197,24,0.95)] active:translate-y-px" data-id="element-187" data-mp="1x7hub9ezzuyr">
              Solicitar una reunión
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-188" data-mp="2g1wtp0581pn4" />
            </a>
            <a href={BRAND.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 rounded-md border border-gold/60 bg-transparent px-7 py-4 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-white transition-all duration-300 hover:border-gold hover:bg-gold/10 active:translate-y-px" data-id="element-189" data-mp="2p0qockyzs5y1">
              <WhatsappIcon className="h-4 w-4 text-gold" data-id="element-190" data-mp="4akzf5h4mwj5" />
              Hablar por WhatsApp
            </a>
          </div>

          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6" data-id="element-191" data-mp="3vh5leasbre9b">
            <span className="font-sans text-[11px] uppercase tracking-[0.28em] text-ash/70" data-id="element-192" data-mp="e88vbyqgya2w">
              {BRAND.instagramHandle}
            </span>
            <SocialLinks data-id="element-193" data-mp="3hqa8mnepgd0g" />
          </div>
        </motion.div>
      </div>

      <div className="hairline" aria-hidden="true" data-id="element-194" data-mp="3hqjzsebhkq7q" />
    </section>;
}